<template>
  <div class="navbar">
    <div class="container">
      <div class="left">
        欢迎来到润标天泽国际认证(北京)有限公司!
      </div>
      <div class="right">
        <template v-if="isLogin">
          <div
            class="flex-item"
            @click="() => handleProfile()"
          >
            {{user.username || user.email || user.mobile}}
          </div>
          <div
            class="flex-item"
            @click="() => handleLogout()"
          >
            退出登录
          </div>
        </template>
        <template v-else>
          <div
            :class="[
              'flex-item',
              `${item.className}`
            ]"
            v-for="(item, i) in data"
            :key="i"
          >
            <div
              @click="handleClick(item)"
            >
              <i class="icon" />
              {{item.label}}
            </div>
          </div>
        </template>
        <div
          class="flex-item navigation"
          @click="() => handleSiteMap()"
        >
          网站导航
          <i class="icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import go from "@/utils/go";
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ... mapState("user", {
      user: state => state
    }),
    isLogin(){
      return this?.user?.token;
    }
  },
  data(){
    return {
      data: [
        {
          label: "登录",
          className: "login"
        },
        {
          label: "注册",
          className: "register"
        }
      ]
    };
  },
  methods: {
    ... mapActions("user", ["logout"]),
    handleProfile(){
      go.to("profile");
    },
    handleLogout(){
      this.logout();
      go.to("login");
    },
    handleClick({ label }){
      if("登录" == label){
        go.to("login");
      }
      else if("注册" == label){
        go.to("register");
      }
    },
    handleSiteMap(){
      self?.scrollTo?.(
        0,
        self?.document?.documentElement?.scrollHeight
      );
    },
    main(){
      if(this.isLogin){
        this.$set(this, "data", [
          {
            label: "网站导航",
            className: "navigation"
          }
        ]);
      }
    }
  },
  mounted(){
    this.main();
  }
};
</script>

<style lang="less" scoped>
.navbar {
  padding: 13px 0;
  background: #efefef;
  .container {
    display: flex;
    .left, .right {
      flex: 1;
    }
    .left {
      text-align: left;

    }
    .right {
      text-align: right;
      display: flex;
      max-width: 330px;
      justify-content: flex-end;
      .flex-item {
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        margin-right: 28px;
        &:last-child {
          margin-right: 0;
        }
        i.icon {
          display: inline-block;
          width: 17px;
          height: 17px;
          background: no-repeat left top;
          background-size: contain;
          vertical-align: sub;
        }
        &.login i.icon {
          background-image: url("~@/static/images/index__login.jpg");
        }
        &.register {
          color: @primary-color;
          i.icon {
            background-image: url("~@/static/images/index__register.jpg");
          }
        }
        &.navigation i.icon {
          width: 12px;
          height: 7px;
          vertical-align: middle;
          background-image: url("~@/static/images/index__01.jpg");
        }
      }
    }
  }
}
</style>